import { useEffect, useState } from "react";

import { useFirebase } from "@meddbriefer/mdb-firebase";

import { getScenarioTypeObject } from "@meddbriefer/scenario-data/index.js";

import { updateSchema } from "./traumaScenario.js";

import SetScenarioNameForm from "./SetScenarioNameForm.js";

export default function NewScenario() {
    const {db} = useFirebase()
    const [scenario, setScenario] = useState(null)

    useEffect(
        () => {
            (async () => {
                const scenTypeData = await getScenarioTypeObject(db, "trauma", "V2")
                setScenario(updateSchema({}, scenTypeData))
                }
            )()
        }, [db]
    )

    return (
        <SetScenarioNameForm scenario={scenario} isClone={false} />
    )
}